import { cn } from '@/lib/utils'
import SectionHead from '@/v2/components/helpers/section-head'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { staggerContainer } from '@/v2/constants/motion'
import { PressNewsType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'
import PressSlider from './press-slider'

interface PressAndReleaseSectionProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: string | React.ReactNode
  description?: string
  articles: PressNewsType[]
}

const PressAndReleaseSection: React.FC<PressAndReleaseSectionProps> = props => {
  const { title, description, articles, className, ...rest } = props

  if (!articles?.length) {
    return null
  }

  return (
    <LazyMotion features={domAnimation}>
      <m.section
        variants={staggerContainer(0.5, 0)}
        initial='hidden'
        whileInView='show'
        viewport={{ amount: 0.25 }}
        className={cn('text-center landing-pages-wr section-spacing', className)}
      >
        <SectionWrapper {...rest}>
          <SectionHead title={title} description={description} />
          <div className='mt-4 md-mn:mt-6' />
          <PressSlider articles={articles} />
        </SectionWrapper>
      </m.section>
    </LazyMotion>
  )
}

export default PressAndReleaseSection
